import axios from 'axios'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { FETCH_EMPRESA_BEGIN as BEGIN, FETCH_EMPRESA_SUCCESS as SUCCESS, FETCH_EMPRESA_FAILURE as FAILURE, GET_ERRORS } from './types'
import { setModalOpen } from './modal'
import { URL_API } from './urls'
import { defaultFetchBegin, defaultFetchSuccess, defaultFetchFailure, defaultFetch, defaultDelete } from './default'

const MySwal = withReactContent(Swal)

const model = 'empresa'

export const fetchBegin = () => defaultFetchBegin(BEGIN)
export const fetchSuccess = data => defaultFetchSuccess(SUCCESS, model, data)
export const fetchFailure = error => defaultFetchFailure(FAILURE, error)
export const fetch = (id = '') => defaultFetch(model, fetchBegin, fetchSuccess, fetchFailure, id)

export const saveEmpresa = (empresa, history, actions) => dispatch => {
    empresa.cnae = empresa.cnae?.map((val)=>val.codigo)

    var formData = new FormData();
    Object.keys(empresa).forEach(function(key) {
        formData.append(key, empresa[key]);
    })

    axios.post(URL_API + 'empresa', formData, {headers: {
            'Content-Type': 'multipart/form-data'
        }})
        .then(res => {
            history.push('/empresa')
            MySwal.fire({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                type: 'success',
                title: 'Empresa salva com sucesso'
            })
            actions.setSubmitting(false)
            dispatch(setModalOpen(''))
            dispatch(fetch())
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
            actions.setErrors(err.response.data.errors)
            actions.setSubmitting(false)
        })
}

export async function fetchDocumentosEmpresaList(reqData, dispatch) {
    const params = new URLSearchParams();

    Object.entries(reqData).forEach(([key, value]) => {
        if (value !== null) {
            params.append(key, value)
        }
    });

    try {
        const { data } = await axios.get(URL_API + 'empresa/documentos', { params });
        return data;
    } catch (err) {
        const error = err.response
            ? err.response.data
            : { message: "Não foi possível obter os documentos da empresa" };

        dispatch({
            type: GET_ERRORS,
            payload: {message: error}
        });

        throw err;
    }
}

export const deleteDocumentoEmpresa = (documento, afterDelete, afterError) =>
    defaultDelete(
        "empresa/documentos",
        documento,
        "Documento excluído com sucesso",
        afterDelete,
        afterError,
        (err) => MySwal.fire({
            title: "",
            type: "error",
            html: err.response.data,
            position: "center",
        })
    );

/**
 * @param {{ documento: number, explicacao: string }} payload
 * @param {() => {}} afterSuccess
 * @param {() => {}} afterError
 * @param {boolean} showSucessMessage
 */
export const addExplicacaoDocumentoEmpresa = async (
    payload,
    afterSuccess,
    afterError,
) => {
    try {
        await axios.post(URL_API + "empresa/documentos", payload);
        MySwal.fire({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            type: "success",
            title: "Explicação enviada com sucesso",
        });

        if (afterSuccess) {
            afterSuccess();
        }
    } catch (error) {
        console.error(error);
        MySwal.fire({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            type: "error",
            title: "Não foi possível salvar a explicação do documento",
        });

        if (afterError) {
            afterError();
        }
    }
}

export async function fetchDocumentosFuncionariosEmpresaList() {
    try {
        const { data } = await axios.get(URL_API + 'empresa/documentos-funcionarios');
        return data;
    } catch (err) {
        throw err;
    }
}

export async function saveDocumentosFuncionariosEmpresa({ documentos = [] }) {
    try {
        const { data } = await axios.post(URL_API + 'empresa/documentos-funcionarios', { documentos });
        return data;
    } catch (err) {
        throw err;
    }
}
